<mat-dialog-content class="session-dialog-content">
  <mat-icon color="primary">warning</mat-icon>
  <h2>Session expires in</h2>
  <h2 *ngIf="timeLeft$ | async as seconds">{{ secondsToMinutes(seconds).minutes }}min {{secondsToMinutes(seconds).seconds}}s</h2>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button (click)="onLogout()">Logout</button>
  <button mat-raised-button color="primary" (click)="onRenewSession()">Renew session</button>
</mat-dialog-actions>